<template>
  <el-row>
    <el-col
      :xl="{ span: 10, offset: 0 }"
      :lg="{ span: 10, offset: 0 }"
      :md="{ span: 10, offset: 0 }"
      :sm="{ span: 10, offset: 0 }"
      :xs="{ span: 24, offset: 0 }"
    >
      <div
        v-loading="isUpdatingThumbnail"
        class="videoThumbContainer"
        @click="$store.state.services.isMediaManager ?  $emit('playVideoInMediaManager', videoInfo.id) : ''"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <!-- Thumbnail regeneratinng button -->
        <el-tooltip
          v-if="videoInfo.status == 'ready' && hidenRenewThumbnile == false "
          content="Click to generate other thumbnail"
        >
          <div class="videoThumbOverlay">
            <autorenew
              class="videoThumbOverlay__icon"
              @click="$emit('renewThumbnail')"
            />
          </div>
        </el-tooltip>
        <div class="owerlayDuration">{{ durationLine }}</div>
        <!-- Video thumbnail (or default) -->
        <thumbnail-image
          v-if="videoInfo.status == 'ready' || videoInfo.status == 'remote'"
          class="videoThumb videoThumb--active"
          :src="playPreview ? previewLink : thumbnailLink"
          :fallback="fallbackImage"
          :loader-c-lose="loaderCLose"
          alt="Video Preview"
          @mouseover="playPreview = true"
          @mouseleave="playPreview = false"
        />
        <thumbnail-image
          v-else
          class="videoThumb"
          :src="fallbackImage"
          :loader-c-lose="loaderCLose"
          alt="Video Preview"
        />
      </div>
    </el-col>
    <el-col
      class="videoInfo"
      :xl="{ span: 10 }"
      :lg="{ span: 13 }"
      :md="{ span: 13 }"
      :sm="{ span: 13 }"
      :xs="{ span: 24 }"
    >
      <!-- <div class="videoInfoParam">
        <span class="videoInfoLabel">App:</span>
        <span class="videoInfoValue">{{ app }}</span>
      </div> -->
      <div class="videoInfoParam">
        <span class="videoInfoLabel">Stream:</span>
        <span class="videoInfoValue">{{ streamDisplayName }}</span>
      </div>
      <!-- <div v-if="duration != null" class="videoInfoParam">
        <span class="videoInfoLabel">Duration:</span>
        <span class="videoInfoValue">{{ durationLine }}</span>
      </div> -->
      <div class="videoInfoParam displayFlex">
        <span class="videoInfoLabel">Time:</span>
        <span class="videoInfoValue"
          >{{ startDateTimeLine }} - {{ endDateTimeLine }}</span
        >
      </div>
      <!-- <div class="videoInfoParam">
        <span class="videoInfoLabel">Start Time:</span>
        <span class="videoInfoValue">{{ startDateTimeLine }}</span>
      </div>
      <div class="videoInfoParam">
        <span class="videoInfoLabel">End Time:</span>
        <span class="videoInfoValue">{{ endDateTimeLine }}</span>
      </div> -->

      <div class="videoInfoParam">
        <span class="videoInfoLabel" @click="startSetTitle">Description:</span>
        <div class="titleContainer">
          <el-input
            v-if="isTitleEditing"
            ref="titleInput"
            v-model="newTitle"
            :title="newTitle"
            size="medium"
            class="videoTitleInput"
            type="textarea"
            @blur="setTitle"
            @keyup.enter.native="setTitle"
            @keyup.esc.native="resetTitle"
          />
          <span
            v-else
            :title="defTitleVideo"
            class="videoTitleLabel videoInfoValue"
            @click="startSetTitle"
            >{{ defTitleVideo }}</span
          >
        </div>
      </div>
      <!-- Sharing list -->
      <div
        v-if="videoInfo.status === 'ready' && showButtonShare === true || videoInfo.status == 'remote' && showButtonShare === true "
        class="video-mangomolo-controls"
      >
        <el-dropdown trigger="click">
          <el-button class="share-dropdown-btn" type="primary">
            {{titleBtn}}
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-if="uploadToMangomolo">
              <div
                class="mangomolo-upload-button"
                @click="$emit('uploadToMangomolo')"
              >
                Upload to mangomolo
              </div>
            </el-dropdown-item>

            <el-dropdown-item v-if="snapchatLink">
              <a :href="snapchatLink" target="_blank">
                <div class="snapchat-share-button">
                  Snapchat
                </div>
              </a>
            </el-dropdown-item>

            <el-dropdown-item>
              <div v-if="channelType === 'video'" class="share-form-button" @click="$emit('openShareModal')">
                Others
                <img class="other-socials-img" :src="twitterIcon" />
                <img class="other-socials-img" :src="instagramIcon" />
                <img class="other-socials-img" :src="facebookIcon" />
                <img
                  class="other-socials-img padding-right"
                  :src="youtubeIcon"
                />
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import ThumbnailImage from "@/components/timeline/thumbnails/ThumbnailImage.vue";
/** assets */
import fallbackImage from "@/assets/images/empty.jpg";
import youtubeIcon from "@/assets/images/youtube_sharing.png";
import facebookIcon from "@/assets/images/facebook_sharing.png";
import instagramIcon from "@/assets/images/instagram_sharing.png";
import twitterIcon from "@/assets/images/twitter_sharing.png";

/** icons */
import Autorenew from "vue-material-design-icons/Autorenew.vue";

import { mapState, mapGetters } from "vuex";

import { getDurationTimeline, getDateAndTimeLine } from "@/utils/time.js";

// @group Media/Video
// Video item information
export default {
  name: "VideoItemContent",
  components: {
    ThumbnailImage,
    Autorenew
  },
  model: {
    prop: "title",
    event: "updateTitle"
  },
  props: {
    channels:{
      type: Array
    },
    hidenRenewThumbnile: {
      type: Boolean,
      default: false
    },
    showButtonShare: {
      type: Boolean,
      required: true
    },
    /** video additional information */
    videoInfo: {
      type: Object,
      required: true
    },
    /** poster */
    thumbnailLink: {
      type: String,
      default: fallbackImage
    },
    /** Wowza live-application name */
    app: {
      type: String,
      default: "No App"
    },
    /** Wowza stream name */
    stream: {
      type: String,
      default: "No Stream"
    },
    /** Audio duration in seconds */
    duration: {
      type: Number,
      default: null
    },
    /** link to share to Snapchat */
    snapchatLink: {
      type: String,
      default: null
    },
    /** is poster refreshing */
    isUpdatingThumbnail: {
      type: Boolean,
      default: false
    },
    /** is clip uploaded to MM */
    uploadToMangomolo: {
      type: Boolean,
      default: true
    },
    loaderCLose: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      defTitleVideo: this.videoInfo?.description ? this.videoInfo?.description : "",
      newTitle: "",
      /** is title changing right now */
      isTitleEditing: false,
      /** show preview/poster */
      playPreview: false,
      /** fallback poster */
      fallbackImage,
      /** icons */
      youtubeIcon,
      facebookIcon,
      instagramIcon,
      twitterIcon
    };
  },
  watch: {
    defTitleVideo() {
      this.$emit("changeDescriptionVideo", this.defTitleVideo);
    },
  },
  methods: {
    // @vuese
    // Start edit clip title
    startSetTitle() {
      this.isTitleEditing = true;
      // User begin title editing
      this.$emit("updateTitleStart");

      // focus input when it will replace span
      this.$nextTick(() => {
        this.$refs.titleInput.focus();
      });
    },
    // @vuese
    // Save entered title
    setTitle() {
      if (this.isTitleEditing) {
        if (this.newTitle.length === 0) {
          this.$refs.titleInput.focus();
          return;
        }
        this.defTitleVideo = this.newTitle;
        // if (this.newTitle !== this.title) {
        //   this.$emit("updateTitle", this.newTitle);
        // }
        this.resetTitle();
      }
    },
    // @vuese
    // Cancel title editing ant return old one
    resetTitle() {
      this.isTitleEditing = false;
    }
  },
  computed: {
    ...mapGetters(["channelType"]),
    ...mapState({
      thumbs: state => state.services.thumbs,
      timezone: state => state.timezone.timezone
    }),
    titleBtn() {
      return this.channelType === 'audio' ? 'Share audio' : 'Share video'
    },
    streamDisplayName(){
      return this.channels ? this.channels.filter(e => e.default_stream == this.videoInfo.stream)[0].display_name : this.videoInfo.stream
    },

    // @vuese
    // Preview video source URL
    previewLink() {
      return this.videoInfo.previewLink && this.videoInfo.status != "remote" 
        ? `${this.videoInfo.storageUrl}/${this.videoInfo.previewLink}`
        : this.thumbnailLink;
    },
    // @vuese
    // Duration time in format HH:mm:ss
    durationLine() {
      return getDurationTimeline(this.duration);
    },
    // @vuese
    // Video start time in format DD-MM-YYYY HH:mm:ss
    startDateTimeLine() {
      return getDateAndTimeLine(this.videoInfo.startTime, this.timezone);
    },
    // @vuese
    // Video end time in format DD-MM-YYYY HH:mm:ss
    endDateTimeLine() {
      return getDateAndTimeLine(this.videoInfo.endTime, this.timezone);
    }
  }
};
</script>

<style>
.snapchat-share-button {
  padding-right: 28px;
  background-image: url("../../../assets/images/snapchat_sharing.png");
  background-position: center right 4px;
  background-size: 20px;
  background-repeat: no-repeat;
}
.snapchat-share-button img {
  float: left;
  border-radius: 5px;
}
img.other-socials-img {
  float: right;
  width: 20px;
  height: 20px;
  padding: 7px 4px 7px 0;
}
</style>

<style lang="scss" scoped>
/** thumbs */
.videoThumbContainer {
  margin: 0 17px;
  position: relative;
  cursor: pointer;
}
.videoThumbOverlay {
  position: absolute;
  z-index: var(--video-thumb-overlay-z);
  right: 0;
  top: 0;
  user-select: none;
  cursor: pointer;
}
.videoThumbOverlay__icon {
  margin-right: 4px;
  margin-top: 4px;
}
.videoThumbOverlay__icon svg {
  width: 1.5rem !important;
  height: 1.5rem !important;
}
.videoThumb {
  width: 100%;
  height: 100%;
  position: relative;
}

/** info */
.videoInfo {
  padding: 10px 20px;
}

.videoInfoParam {
  justify-self: start;
  text-align: start;
  margin-bottom: 4px;
  font-size: 14px;
}
.videoInfoLabel {
  width: 5rem;
  margin-right: 5px;
  display: inline-block;
  color: #ffffff;
}
.videoInfoLabel:hover {
  cursor: pointer;
}
.videoInfoValue {
  margin-right: 5px;
  display: inline-block;
  color: white;
}

/** sharing */
.video-mangomolo-controls {
  display: flex;
  flex-wrap: wrap;
  margin: 5px 0 5px 0;
}
.video-mangomolo-controls .el-button {
  margin: 5px 5px 5px 0;
}
.displayFlex {
  display: flex;
}
.owerlayDuration {
  position: absolute;
  z-index: 1;
}
.mangomolo-upload-button {
  padding-right: 28px;
  background-image: url("../../../assets/logo-small.png");
  background-position: center right 0px;
  background-size: 20px;
  background-repeat: no-repeat;
}
.share-dropdown-btn {
  height: 30px;
  padding-top: 5px;
  padding-bottom: 5px;

  border: none;

  color: white;
  background-color: var(--grey);
}
.snapchat-share-button {
  color: white !important;
  text-decoration: none;
}

/** icons */
.material-design-icon__svg {
  padding-left: 2px;
  height: 0.7rem !important;
  width: 0.7rem !important;
  margin-top: 1px !important;
}

.padding-right {
  margin-left: 7px;
}

@media only screen and (max-width: 767px) {
  .video-mangomolo-controls {
    justify-content: center;
  }
  /** video info */
  .videoInfoParam {
    margin-left: 15px;
    margin-top: 5px;
    font-size: 13px;
  }
  .videoInfoLabel {
    width: 6rem;
  }
  .videoInfoLabel:hover {
    cursor: pointer;
  }
}

@media only screen and (min-width: 768px) {
  /** video info */
  .videoInfoParam {
    font-size: 16px;
  }
  .videoInfoLabel {
    width: 6rem;
  }
  .videoInfoLabel:hover {
    cursor: pointer;
  }
}

@media only screen and (min-width: 992px) {
  /** Video thumbnail */
  .videoThumb {
    max-height: 160px;
    object-fit: contain;
  }
  /** video info */
  .videoInfoParam {
    font-size: 11px;
  }
  .videoInfoLabel {
    width: 4rem;
  }
  .videoInfoLabel:hover {
    cursor: pointer;
  }
}

@media only screen and (min-width: 1200px) {
  /** video info */
  .videoInfoParam {
    font-size: 13px;
  }
  .videoInfoLabel {
    width: 3rem;
  }
  .videoInfoLabel:hover {
    cursor: pointer;
  }
  .material-design-icon__svg {
    height: 1rem !important;
    width: 1rem !important;
    margin-top: 2px !important;
  }
}
.titleContainer {
  text-align: start;
}
.videoTitleInput {
  margin-right: 5px;
  margin-top: 5px;
  font-size: 10px;
}
.videoTitleLabel {
  font-size: 13px;
  max-width: 100%;
  display: inline-block;
  margin-right: 10px;
  text-decoration: none;
  border-bottom: 1px dashed #ffffff;
  cursor: pointer;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  max-width: 235px;
}

@media only screen and (max-width: 767px) {
  .videoTitleLabel {
    font-size: 12px;
  }
}
@media only screen and (min-width: 1500px) {
  .videoTitleLabel {
    font-size: 15px !important;
  }
}
@media only screen and (min-width: 1920px) {
  .videoTitleLabel {
    font-size: 17px !important;
  }
}

@media only screen and (min-width: 1920px) {
  /** video info */
  .videoInfoParam {
    font-size: 14px;
  }
  .videoInfoLabel {
    width: 6rem;
  }
  .videoInfoLabel:hover {
    cursor: pointer;
  }
  .material-design-icon__svg {
    height: 1rem !important;
    width: 1rem !important;
    margin-top: 2px !important;
  }
}
</style>
